import passiveEvents from '../../utils/passive-events';

export default function touchControl(presentations) {
  let startTouch = null;
  let presentation = null;
  let startTime = 0;
  let isPossiblyRelevant = false;
  const opts = passiveEvents ? { passive: false } : false;

  function diff(touch) {
    const yDiff = startTouch.pageY - touch.pageY;
    const yDiffAbs = Math.abs(yDiff);
    return Math.min(yDiffAbs / window.innerHeight, 0.99) * Math.sign(yDiff);
  }

  document.addEventListener(
    'touchstart',
    e => {
      const { target } = e;
      if (!e.touches || e.touches.length !== 1) {
        return;
      }

      isPossiblyRelevant =
        target.closest &&
        (target.closest('button') ||
          target.closest('a') ||
          target.closest('input') ||
          target.closest('textarea') ||
          target.closest('select'));

      [startTouch] = e.touches;
      // e.preventDefault(); it may be scrolling
      ({ presentation } = presentations);
      presentation.timeline.pause();
      startTime = presentation.time();
    },
    opts,
  );

  document.addEventListener(
    'touchmove',
    e => {
      if (
        !startTouch ||
        !e.cancelable || // is scrolling
        !e.touches ||
        e.touches.length !== 1 ||
        e.touches[0].identifier !== startTouch.identifier
      ) {
        return;
      }

      // console.log('touchmove');

      e.preventDefault();
      const [touch] = e.touches;
      const timeDiff = diff(touch);
      const timeDiffAbs = Math.abs(timeDiff);

      presentation.time(
        Math.max(
          0,
          startTime +
            Math.sign(timeDiff) * presentation.easeReverse(timeDiffAbs),
        ),
      );
    },
    opts,
  );

  document.addEventListener(
    'touchend',
    e => {
      if (
        !startTouch ||
        !e.cancelable || // is scrolling
        !e.changedTouches ||
        e.changedTouches.length !== 1 ||
        e.changedTouches[0].identifier !== startTouch.identifier
      ) {
        return;
      }

      // console.log('touchend');

      if (!isPossiblyRelevant) {
        e.preventDefault();
      }

      const [touch] = e.changedTouches;
      const timeDiff = diff(touch);
      const absDiff = Math.abs(timeDiff);
      const isConfirmedMove = absDiff > 0.12;
      const direction = Math.sign(timeDiff) * (isConfirmedMove ? 1 : -1);
      const directionMethod = direction === -1 ? 'prev' : 'next';
      const timeMoved = presentation.timeline.time() % 1;

      // console.log(absDiff, direction, timeMoved, presentation.timeline.time());

      if (direction && (isConfirmedMove || timeMoved !== 0)) {
        presentations.presentation[directionMethod]();
      }

      startTouch = null;
    },
    opts,
  );
}



// WEBPACK FOOTER //
// ./src/scripts/modules/control/touchControl.js